
import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HTTP } from '@ionic-native/http';
import { Globals } from '../../../globals';
import { AuthServices } from '../../auth/services';
import { ConfigurationServices } from '../../configuration/services';
import { SchoolServices } from '../services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-teachers-create',
  templateUrl: 'teachers-create.html',
})
export class TeachersCreatePage {

  public form: FormGroup;
  public user: any;
  loadingPopup: any;
  type: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public globals: Globals,
    public authServices: AuthServices,
    private http: HTTP,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public schoolServices: SchoolServices,
    public translate: TranslateService) {

    //Params
    //this.type = this.navParams.get('type');

    this.loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-creando-profesor')
    });

    this.form = this.fb.group({
      name: [''],
      email: ['', Validators.compose([Validators.required])],
      rol: ['teacher'],
      password: ['', Validators.compose([Validators.required])],
      password_confirmation: ['', Validators.compose([Validators.required])],
    });
  }


  onBack() {
    this.navCtrl.pop();
  }


  /*private MatchPassword(AC: AbstractControl) {
    const newPassword = AC.get('password').value;// to get value in input tag
    const confirmPassword = AC.get('password_confirmation').value;// to get value in input tag
    if (newPassword != confirmPassword) {
      AC.get('password_confirmation').setErrors({ MatchPassword: true })
    } else {
      AC.get('password_confirmation').setErrors(null);
    }
  }*/
  error_password_message: string = '';
  _send_form: boolean = false;
  checkPasswordU() {
    if (this.form.value.password.length < 7) {
      this._send_form = false;
      this.error_password_message = ' La contraseña debe tener más de 6 caracteres'
    } else if (this.form.value.password == this.form.value.password_confirmation) {
      this._send_form = true;
      this.error_password_message = '';
    } else {
      this._send_form = false;
      this.error_password_message = 'Las contraseñas no son iguales.'
    }
  }



  submit() {
    if (this.form.valid) {
      this.insert();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-email-contrasena'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  async insert() {
    /*CREAR USER EN FirebBase*/
    this.loadingPopup.present();

    this.http.post(this.globals.api_path + 'user', {
      email: this.form.value.email,
      password: this.form.value.password
    }, {})
      .then(async data => {
        //create user in fb
        await this.schoolServices.createUser(this.form.value.email, this.form.value.name, data.data,
          this.globals.school_uid, this.form.value.rol);
        //add teacher in teachers
        this.schoolServices.addUserInTeachers(this.form.value.name, this.form.value.email, this.globals.school_uid, this.schoolServices.uid_user);


        this.loadingPopup.dismiss();
        this.navCtrl.pop();
      })
      .catch(async uid => {

        var exists = await this.schoolServices.existsTeacher(this.form.value.email);

        if (!exists) {

          await this.schoolServices.createUser(this.form.value.email, this.form.value.name, uid,
            this.globals.school_uid, this.form.value.rol);
          //add teacher in teachers
          this.schoolServices.addUserInTeachers(this.form.value.name, this.form.value.email, this.globals.school_uid, this.schoolServices.uid_user);
          this.loadingPopup.dismiss();
          this.navCtrl.pop();
        } else {
          this.loadingPopup.dismiss();
          let toast = this.toastCtrl.create({
            message: this.translate.instant('instant-introduce-email-contrasena'),
            duration: 3000,
            position: 'bottom'
          });
          toast.present();
        }


      });
  }



}



// WEBPACK FOOTER //
// ./src/pages/schools/teachers-create/teachers-create.ts